var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"choose_payment_page"},[(_vm.step === 1)?_c('ChooseService',{on:{"toPayment":function($event){_vm.step = 2}}}):_vm._e(),(_vm.step === 2)?_c('Payment'):_vm._e()],1)}
var staticRenderFns = []

export { render, staticRenderFns }